<template>
    <div>
        <v-card hover class="ma-2 mb-4" dark color="primary" v-if="showDonation">
            <v-card-text class="">
                <span class="secondary--text font-weight-bold text-subtitle-1">Support our favourite charities with a $1 donation. <a target="_blank" :href="`${baseUrl}/about/community/giving-back/`" class="secondary--text"><u>Click here</u></a> to learn more.</span>
                <v-switch class="font-weight-bold" color="secondary" :label="donationLabel" v-model="giveDonation" @change="updateDonation"></v-switch>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import store from "./_store";

export default {
    name: "DonationModule",
    props: {
        //props
    },
    data() {
        return {
            productDonation: {},
            giveDonation: false,
            showDonation: true,
            baseUrl: window.LMP.baseUrl,
        };
    },
    computed: {
        donationLabel(){
            return this.productDonation.product_name + ' - ' + this.$options.filters.currency(this.productDonation.product_price);
        },
        donationCart() {
            return this.$store.getters["donation/donationCart"];
        },
    },
    methods: {
        updateDonation(){
            if (!_.isEmpty(this.productDonation)) {
                if(this.giveDonation){
                    this.$store.dispatch("donation/addDonation", this.productDonation);
                } else {
                    this.$store.dispatch("donation/removeDonation", this.productDonation);
                }
            }
        },
    },
    mounted() {
        this.$store.dispatch("donation/getProductDonation").then(product => {
            if(product.data){
                this.productDonation = product.data;
                this.$store.dispatch("donation/removeDonation", this.productDonation);
            } else{
                this.showDonation = false;
            }
        });
    },
    created() {
        //created vuejs cycle
    },
};
</script>

<style scoped></style>
